// @flow

/**
 * Module dependencies.
 */

import { identity } from 'lodash';

/**
 * Entities.
 */

function entities(translate: Function = identity): Object {
  return {
    contacts: [{
      address: '8 The Green, Ste A, Dover, Kent 19901<br>United States',
      key: 'usa',
      link: '',
      phone: '+1 503 819 0414',
      title: 'Wayfex Inc.'
    }, {
      address: 'Avenida da República, 50<br>2º Andar<br>1050-196 Lisboa, Portugal',
      key: 'eur',
      link: 'https://www.google.com/maps/place/Av.+da+Rep%C3%BAblica+50+2%C2%BA+Piso,+1050-196+Lisboa/@38.7406179,-9.1482987,17z/data=!3m1!4b1!4m5!3m4!1s0xd193309da5a0545:0xd9b6833e1793afe!8m2!3d38.7406179!4d-9.14611',
      phone: '(+351) 939 424 550',
      title: 'Wayfex Europe'
    }, {
      address: 'Espaços Avenida, Loja LPR 002, Via A1<br>Bairro de Talatona<br>Município de Belas<br>Luanda, Angola',
      key: 'ao',
      link: '',
      phone: '(+244) 927 780 383',
      title: `${translate('contacts.angolaContact')}:<br>Unitransfer`
    }],
    footerLinks: [{
      isMobile: false,
      key: 'about',
      title: translate('footer.links.about')
    }, {
      isMobile: false,
      key: 'contacts',
      title: translate('footer.links.contactUs')
    }, {
      isMobile: true,
      key: 'licensedRepresentatives',
      title: translate('footer.links.licensed')
    }, {
      isMobile: true,
      key: 'termsOfService',
      title: translate('footer.links.termsOfService')
    }, {
      isMobile: true,
      key: 'privacy',
      title: translate('footer.links.privacy')
    }],
    homeCta: {
      button: {
        key: 'howItWorks',
        label: translate('homepage.moneyTransfer.howItWorks.cta')
      },
      hint: translate('homepage.moneyTransfer.howItWorks.hint'),
      lead: translate('homepage.moneyTransfer.howItWorks.lead')
    },
    homeFeatures: [{
      description: translate('homepage.features.rates.description'),
      icon: 'feature-fair-rates',
      title: translate('homepage.features.rates.title')
    }, {
      description: translate('homepage.features.licensed.description'),
      icon: 'feature-licensed',
      title: translate('homepage.features.licensed.title')
    }, {
      description: translate('homepage.features.safe.description'),
      icon: 'feature-safe',
      title: translate('homepage.features.safe.title')
    }],
    homeMoneyTransferGlobal: {
      description: translate('homepage.moneyTransfer.global.description'),
      lead: translate('homepage.moneyTransfer.global.lead'),
      title: translate('homepage.moneyTransfer.global.title')
    },
    homeMoneyTransferSecurity: {
      description: translate('homepage.moneyTransfer.security.description'),
      lead: translate('homepage.moneyTransfer.security.lead'),
      title: translate('homepage.moneyTransfer.security.title')
    },
    languages: [{
      label: translate('languages.en'),
      value: 'en'
    }, {
      label: translate('languages.pt'),
      value: 'pt'
    }],
    legalSideMenu: [{
      key: 'termsOfService',
      title: translate('legalAndCompliance.sideMenu.termsOfService')
    }, {
      key: 'unitransferTermsOfService',
      title: translate('legalAndCompliance.sideMenu.unitransferTermsOfService')
    }, {
      key: 'privacy',
      title: translate('legalAndCompliance.sideMenu.privacy')
    }],
    mainMenu: [{
      key: 'about',
      title: translate('menu.about')
    }, {
      key: 'forAgents',
      title: translate('menu.forAgents')
    }, {
      key: 'howItWorks',
      title: translate('menu.howItWorks')
    }, {
      key: 'compliance',
      title: translate('menu.compliance')
    }, {
      key: 'contacts',
      title: translate('menu.contactUs')
    }],
    transferringItems: [
      translate('transferring.items.item1'),
      translate('transferring.items.item2'),
      translate('transferring.items.item3')
    ]
  };
}

/**
 * Export memoized entities.
 */

export default entities;



// WEBPACK FOOTER //
// ../src/client/core/entities/index.js